module.exports = __webpack_public_path__ + "img/2.2_Russian_road_sign.6e6793b7.svg";